import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/navlayer/enable/navlayer.enable.mutation.gql"
import type {
  NavLayerEnableMutation,
  NavLayerEnableMutationVariables,
} from "@/v2-backoffice-client/navlayer/enable/__types__/navlayer.enable.mutation"

type Options = MutationHookOptions<
  NavLayerEnableMutation,
  NavLayerEnableMutationVariables
>

export function useNavLayerEnableMutation(options?: Options) {
  return useMutation<NavLayerEnableMutation, NavLayerEnableMutationVariables>(
    mutation,
    options,
  )
}
